export default "__VITE_ASSET__DTxyk_yU__"